import React, { createContext, useContext, useRef, useState, useCallback, useEffect } from "react";
import Lenis from "lenis";
import { useReducedMotion } from "framer-motion";

const FormContext = createContext(null);

export function FormProvider({ children }) {
  const formRef = useRef(null);
  const waysRef = useRef(null);
  const lenisRef = useRef(null);
  const reduce = useReducedMotion();
  const [prefill, setPrefill] = useState(null);

  useEffect(() => {
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); lenisRef.current = null; };
  }, [reduce]);

  const scrollToTarget = useCallback((target) => {
    if (!target) return;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(target, { offset: -70, duration: 1.2 });
    } else {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  const scrollToId = useCallback((id) => {
    scrollToTarget(document.getElementById(id));
  }, [scrollToTarget]);

  const scrollToWays = useCallback(() => scrollToTarget(waysRef.current), [scrollToTarget]);

  const requestAvailability = useCallback((options = {}) => {
    setPrefill({ ...options, _ts: Date.now() });
    setTimeout(() => scrollToTarget(formRef.current), 80);
  }, [scrollToTarget]);

  return (
    <FormContext.Provider
      value={{ formRef, waysRef, prefill, setPrefill, requestAvailability, scrollToWays, scrollToId }}
    >
      {children}
    </FormContext.Provider>
  );
}

export const useForm = () => useContext(FormContext);
